import React, { useRef } from 'react';
import { FILE_PICKER } from '../utils/constants';

interface FileLoaderProps {
  onFileLoad: (file: File) => void;
  isLoading: boolean;
}

const FileLoader: React.FC<FileLoaderProps> = ({ onFileLoad, isLoading }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    onFileLoad(file);

    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept={FILE_PICKER.LOAD_ACCEPT}
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
      <button
        onClick={handleButtonClick}
        disabled={isLoading}
        className="load-file-button"
      >
        {isLoading ? 'Loading...' : '📁 Load File'}
      </button>
    </>
  );
};

export default FileLoader;